import { render } from "./DefaultsPricing.vue?vue&type=template&id=5efd4257&scoped=true"
import script from "./DefaultsPricing.vue?vue&type=script&lang=js"
export * from "./DefaultsPricing.vue?vue&type=script&lang=js"

import "./DefaultsPricing.vue?vue&type=style&index=0&id=5efd4257&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5efd4257"]])

export default __exports__